import { ActionsFactory } from '../factories/actions.factory';
import { ActionTypesFactory } from '../factories/actionTypes.factory';

export const TimeframesActions = new ActionsFactory('timeframes', ActionTypesFactory('TIMEFRAMES'));
